import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DisabilityBadge extends Vue {
  @Prop() public disability;
  @Prop() public icon;

  get disabilityIconStyle() {
    return `
      -webkit-mask: url(${this.icon}) no-repeat center/ 18px;
      mask: url(${this.icon}) no-repeat center/ 18px;
    `;
  }
}
